import { render } from "./TourPoint.vue?vue&type=template&id=69056bc5"
import script from "./TourPoint.vue?vue&type=script&lang=js"
export * from "./TourPoint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/views/TourPoint.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69056bc5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69056bc5', __exports__)) {
    api.reload('69056bc5', __exports__)
  }
  
  module.hot.accept("./TourPoint.vue?vue&type=template&id=69056bc5", () => {
    api.rerender('69056bc5', render)
  })

}


export default __exports__